import styles from "./styles/vocal-remove-button.module.scss";
import FilledButton from "@/components/common/filled-button";
import { useEffect, useState } from "react";
import { useStartVocalRemover } from "@/components/pages/vocal-remover/hooks/use-start-vocal-remove";

interface VocalRemoverButtonProps {
  songFile: File | null;
}

const VocalRemoveButton = ({ songFile }: VocalRemoverButtonProps) => {
  const [isActive, setIsActive] = useState<boolean>(false);

  useEffect(() => {
    setIsActive(!!songFile);
  }, [songFile]);

  const { startVocalRemove } = useStartVocalRemover();

  return (
    <div className={styles.button}>
      <FilledButton
        text={"REMOVE VOCAL"}
        backgroundColor={"#FF5722"}
        disabled={!isActive}
        color={"#F2F2F2"}
        onClick={() =>
          startVocalRemove({
            songFile: songFile!,
          })
        }
      />
    </div>
  );
};

export default VocalRemoveButton;
